export const FETCH_ALLPROFESSION_REQUEST = 'FETCH_ALLPROFESSION_REQUEST'
export const FETCH_ALLPROFESSION_SUCCESS = 'FETCH_ALLPROFESSION_SUCCESS'
export const FETCH_ALLPROFESSION_FALIURE = 'FETCH_ALLPROFESSION_FALIURE'
